import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Supabase Client — liest Keys aus .env (VITE_ Prefix).
 *
 * Fehlt die .env-Datei, startet die App nicht.
 * Siehe .env.example für die benötigten Variablen.
 */
const SUPABASE_URL: string | undefined = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY: string | undefined = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error(
    '[DRPX] Supabase-Konfiguration fehlt!\n' +
      'Erstelle eine .env-Datei im Projektroot mit:\n' +
      '  VITE_SUPABASE_URL=https://dein-projekt.supabase.co\n' +
      '  VITE_SUPABASE_ANON_KEY=dein-anon-key\n' +
      'Siehe .env.example',
  );
}

// ─── Client Init ───
export let _sb: SupabaseClient | null = null;
try {
  if (SUPABASE_URL && SUPABASE_ANON_KEY) {
    _sb = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        flowType: 'pkce',
        detectSessionInUrl: true,
        persistSession: true,
        // Finding E1 Fix (18.04.2026): Die vorherige No-op-Lock
        // erlaubte parallelen Token-Refresh zwischen Tabs, was zu
        // Token-Rotation-Races und sporadischen Logouts führte.
        // Wir lassen die `lock`-Option weg — Supabase nutzt dann
        // automatisch den Web-Locks-API-basierten Default (navigatorLock),
        // der Refresh-Requests pro Origin korrekt serialisiert.
      },
    });
  }
} catch (e: unknown) {
  console.error('[DRPX] Supabase init failed:', e);
}

export { SUPABASE_URL, SUPABASE_ANON_KEY };
